import { Controller } from "@hotwired/stimulus"

// Turns a native file input into a labelled button with a live preview.
//
// The native control is kept in the DOM (only visually hidden) so Active
// Storage direct upload and normal form submission keep working untouched —
// this controller never intercepts the submit, it only reflects the choice.
//
// Targets: input (the file field), name (filename text), preview (an <img>),
// placeholder (shown while no image is chosen).
export default class extends Controller {
  static targets = ["input", "name", "preview", "placeholder"]
  static values = { empty: String }

  connect() {
    this.objectUrl = null
  }

  open() {
    this.inputTarget.click()
  }

  changed() {
    const file = this.inputTarget.files && this.inputTarget.files[0]

    if (this.hasNameTarget) {
      this.nameTarget.textContent = file ? file.name : this.emptyValue
    }

    if (!file || !this.hasPreviewTarget) return

    // Revoke the previous blob URL before replacing it, or every re-pick leaks.
    this.release()
    this.objectUrl = URL.createObjectURL(file)
    this.previewTarget.src = this.objectUrl
    this.previewTarget.classList.remove("hidden")
    if (this.hasPlaceholderTarget) this.placeholderTarget.classList.add("hidden")
  }

  disconnect() {
    this.release()
  }

  release() {
    if (this.objectUrl) URL.revokeObjectURL(this.objectUrl)
    this.objectUrl = null
  }
}
